import { render, staticRenderFns } from "./edituser.vue?vue&type=template&id=6ebf4239&"
import script from "./edituser.vue?vue&type=script&lang=js&"
export * from "./edituser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports